import axios, { AxiosResponse } from "axios";
import React, { useEffect, useRef, useState, useContext, FunctionComponent } from "react";
import { Dropdown } from "semantic-ui-react";
import { config } from "../../contexts/UrlContext";
import { toast } from "react-toastify";
import AuthContext from "../../contexts/AuthContext";
import { getRequest, postRequest } from "../../services/axiosService";

interface IProps {
    id: string,
    currentValue: any,
    placeHolder: string,
    type: string,
    name:string,
    callback: any,
    fieldInfo: any,
    endpoint: string,
    additionalOptions: string | null
    canClear: boolean
}

const ContentManagerSearcher: FunctionComponent<IProps> = ({id, currentValue, placeHolder, callback, endpoint, additionalOptions, name, canClear}) => {

    const { auth } = useContext(AuthContext);

    const [value, setValue] = useState<string>("");
    const [text, setText] = useState<string>(placeHolder);
    const [placeHolderTxt, setPlaceHolder] = useState<string>(placeHolder);
    const [options, setOptions] = useState<any[]>([]);
    const [init, setInit] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false);

    const timerRef = useRef<any>(null);


    useEffect(() => {
        if (currentValue && (init || (currentValue.value !== value))) {
            setValue(currentValue.value);
            setText(currentValue.text);
            setPlaceHolder(currentValue.text);
            setInit(false);
        }
    }, [currentValue])

    useEffect(() => {}, [value])

    const getCMResults = async (query:any) => {
        setLoading(true);
        try {
            let response: AxiosResponse = await getRequest(auth, `/Search/${endpoint}?query=${query}${additionalOptions ? additionalOptions : ""}`);

            if (response) {
                let results = response.data.map((result: any) => {
                    return {
                        key: result.value,
                        text: result.name,
                        name: result.name,
                        value: result.value,
                        image: result.image
                    }
                });
                setOptions(results);
            }
            
        } catch (e) {
            let error: any = e;
            console.log(error.response);
            toast.error("Error getting results"); 
            setOptions([]);
        }
        setLoading(false);
    }

    const onSearchChange = (e:any, value:any) => {
        let duration = 1000; // delay

        clearTimeout(timerRef.current);
        timerRef.current = setTimeout(async ()=>{
            await getCMResults(value.searchQuery);
      }, duration);
    }

    const onChange = (e:any, data:any) => {
        const value = data.options.find((x:any) => x.value === data.value);
        let obj = {
            name: name,
            value: value.value,
            text: value.text,
            image: value.image
        };

        setValue(value.value);
        setPlaceHolder(value.text);
        setText(value.text);
        callback(obj);
    }

    const handleClick = (e:any) => {
        if(!e.target.value || e.target.value === "") {
            getCMResults("favorite");
        }
    }

    return (
        <Dropdown
            style={{ backgroundColor: "#e5e5e5", marginBottom: 10 }}
            id={id}
            className="bgGrey" 
            placeholder={placeHolderTxt}
            text={text}
            fluid
            loading={loading}
            search={(i) => i}
            selection
            value={value}
            options={options}
            onSearchChange={onSearchChange}
            onChange={onChange}
            onClick={handleClick}
        />
    );
}

export default ContentManagerSearcher;